module.exports = __webpack_public_path__ + "img/More Printings.0a42dfd1.svg";